/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentProcessingReceiptProcessingStatus =
    (typeof DocumentProcessingReceiptProcessingStatus)[keyof typeof DocumentProcessingReceiptProcessingStatus];

export const DocumentProcessingReceiptProcessingStatus = {
    Classified: 'Classified',
    Failed: 'Failed',
    Skipped: 'Skipped',
    Pending: 'Pending',
} as const;
